import { useEffect, useState } from "react";
import { format, parseISO } from "date-fns";
import { api } from "@/lib/api";

export const ActivityPanel = () => {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/admin/twentyi/activity").then((r) => setRows(r.data)).catch(() => setRows([])); }, []);
  if (!rows) return <p className="text-sm text-slate-500">Loading…</p>;
  return (
    <table data-testid="activity-table" className="w-full text-left text-sm text-slate-200">
      <thead className="text-xs text-slate-500"><tr><th>When</th><th>Who</th><th>Action</th><th>Target</th><th>Result</th></tr></thead>
      <tbody>
        {rows.map((a, i) => (
          <tr key={`${a.at}-${i}`} data-testid={`activity-row-${i}`} className="border-t border-white/5 align-top">
            <td className="whitespace-nowrap py-1.5 pr-3 text-xs text-slate-400">{a.at ? format(parseISO(a.at), "MMM d HH:mm") : ""}</td>
            <td className="pr-3 text-xs">{a.admin}</td><td className="pr-3">{a.action}</td><td className="pr-3 font-mono text-xs">{a.target}</td>
            <td className={a.result === "ok" ? "text-emerald-300" : "text-red-300"} title={a.detail || ""}>{a.result}</td>
          </tr>
        ))}
        {!rows.length && <tr><td colSpan={5} className="py-3 text-slate-500">No 20i changes yet.</td></tr>}
      </tbody>
    </table>
  );
};
